/** Strings owned by `src/features/departments/` — WP-12's Departments
 * section in the normal app (§ Bedrijfscontext, § Zichtbaarheid). */
export const departments = {
  page: {
    title: 'Départements',
    leadPersonal: 'Départements dont vous êtes membre.',
    leadCompany: 'Départements chez {{company}}.',
  },
  list: {
    cardTitle: 'Départements',
    name: 'Nom',
    company: 'Entreprise',
    statistics: 'Statistiques',
    collectiveConsent: 'Consentement collectif',
    inForce: 'en vigueur',
    none: '—',
    unattached: 'non rattaché',
    empty: 'Aucun département ici pour le moment.',
    newDepartment: 'Nouveau département',
  },
  compare: {
    cardTitle: 'Comparaison des départements',
    pageTitle: 'Comparaison des départements',
    lead: 'Comparaison des départements dont vous pouvez voir les statistiques.',
    empty: 'Aucun département ici n’a de statistiques que vous pouvez voir.',
  },
  detail: {
    thisDepartment: 'le département',
    edit: 'Modifier',
    setVisibility: 'Définir la visibilité',
    collectiveConsent: 'Consentement collectif',
    coach: 'Coach',
    category: 'Catégorie',
    type: 'Type',
    statistics: 'Statistiques',
    notRecorded: 'non enregistré',
    membersCardTitle: 'Membres',
    statsCardTitle: 'Statistiques',
    settingsCardTitle: 'Paramètres',
    addPerson: 'Ajouter une personne',
    name: 'Nom',
    nickname: 'Surnom',
    login: 'Connexion',
    yes: 'oui',
    no: 'non',
    noMembers: 'Aucun membre.',
  },
  form: {
    newTitle: 'Nouveau département',
    newLead:
      'Chaque nouveau département commence en aggregate-only — l’état protecteur de la vie privée obtenu en ne faisant rien.',
    name: 'Nom',
    category: 'Catégorie',
    type: 'Type',
    cancel: 'Annuler',
    create: 'Créer le département',
    editTitle: 'Modifier le département',
    save: 'Enregistrer',
    deleteCardTitle: 'Supprimer',
    deleteButton: 'Supprimer ce département',
    deleteConfirm: 'Supprimer {{name}} définitivement ?',
    deleteKeep: 'Conserver',
    deleteYes: 'Oui, supprimer',
    visibilityTitle: 'Visibilité des statistiques',
    visibilityLead:
      'individual n’expose en soi personne : cela permet un accès individuel là où une base de consentement couvre le membre. Passer à individual sans consentement collectif crée une demande de consentement en attente pour chaque membre actuel.',
    visibilityAggregate: 'aggregate — chiffres de groupe uniquement',
    visibilityIndividual: 'individual — accès par membre là où le consentement le couvre',
    collectiveConsentTitle: 'Base de consentement collectif',
    collectiveConsentLead:
      'Tant qu’un accord collectif est en vigueur, il couvre chaque membre de {{name}}, quelle que soit sa réponse personnelle. Les réponses propres des membres sont conservées et reprennent effet dès qu’il est révoqué.',
    collectiveConsentNote: 'Accord hors plateforme (identifiez-le précisément)',
    collectiveConsentRecord: 'Enregistrer la base collective',
    revokeCardTitle: 'Révoquer',
    revokeButton: 'Révoquer la base collective',
  },
} as const;
